/*
 * Copyright (c) 2025 Amazon.com, Inc. or its affiliates. All rights reserved.
 *
 * PROPRIETARY/CONFIDENTIAL. USE IS SUBJECT TO LICENSE TERMS.
 */

import createImageResizer from 'image-blob-reduce';

const imageResizer = createImageResizer();

// Monkey-patch function to set image quality
// https://github.com/nodeca/image-blob-reduce?tab=readme-ov-file#customization
imageResizer._create_blob = async function (env) {
  const blob = await this.pica.toBlob(
    env.out_canvas!,
    env.blob.type,
    0.8 /* quality */,
  );
  env.out_blob = blob;
  return env;
};

type CompressImageOptions = Omit<
  createImageResizer.ResizeOptions,
  'cancelToken'
> & {
  signal?: AbortSignal;
};

export async function compressImage(
  file: File,
  options: CompressImageOptions = {},
): Promise<File> {
  const {signal, ...imageResizerOptions} = options;
  console.info(`Compressing ${file.name}`);

  const cancelToken = new Promise((_, reject) => {
    if (signal?.aborted) {
      reject(signal.reason);
      return;
    }

    signal?.addEventListener('abort', () => reject(signal.reason), {
      once: true,
    });
  });
  const blob = await imageResizer.toBlob(file, {
    cancelToken,
    ...imageResizerOptions,
  });

  return new File([blob], file.name, {type: file.type});
}
